export default "/images/vendor/flag-icon-css/flags/4x3/sm.svg?7e23c95234800a7c7e1e0a03e8b3702e";